// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.latest-deals.not-spread{width:30px;margin-left:auto;margin-right:auto;margin-top:10px}.deal-share-header,.latest-deals>span{display:flex;align-items:center;flex-direction:column}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
